import axios from 'axios'
import { BUSCAR_RESERVAS_EXCESSO_BAGAGEM } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarPedidoExcessoBagagem (parametros) {
  return dispatch => axios.post(`${URL}/reserva/reservas-excesso-bagagem`, parametros, SLOW_REQUEST_CONFIG).then(
    response => dispatch({
      type: BUSCAR_RESERVAS_EXCESSO_BAGAGEM,
      payload: {
        reservas: response.data,
      }
    })
  )
}
